import React, { useEffect, useState } from "react";
import { Button, Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { mpTapGoBack } from "Shared/Mixpanel/AssetsManager";
import { Tokens } from "Shared/Tokens";

const Transaction = (props) => {
    const {
        title = "",
        visible = false,
        onClose = () => {},
        backCTAAction = () => {},
        component = <div />,
    } = props;

    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" ? window.innerWidth < 768 : false
    );

    useEffect(() => {
        if (typeof window === "undefined") return undefined;
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div>
            <Drawer
                title={
                    <div
                        style={{
                            maxWidth: Tokens.containerMaxWidth,
                            margin: "0 auto",
                            width: "100%",
                            color: Tokens.textPrimary,
                            fontWeight: 500,
                            fontSize: "18px",
                        }}
                    >
                        {title}
                    </div>
                }
                placement={isMobile ? "bottom" : "right"}
                closable
                closeIcon={
                    <CloseOutlined style={{ color: Tokens.textSecondary }} />
                }
                width={isMobile ? "100%" : 480}
                height={isMobile ? "88%" : "100%"}
                push={false}
                onClose={onClose}
                open={visible}
                maskClosable
                maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
                headerStyle={{
                    backgroundColor: Tokens.bg,
                    borderBottom: `1px solid ${Tokens.hairline}`,
                }}
                bodyStyle={{
                    backgroundColor: Tokens.bg,
                    padding: "20px 16px",
                }}
                footerStyle={{
                    backgroundColor: Tokens.card,
                    borderTop: `1px solid ${Tokens.hairline}`,
                    padding:
                        "12px 16px calc(12px + env(safe-area-inset-bottom, 0px))",
                }}
                footer={
                    <div
                        style={{
                            maxWidth: Tokens.containerMaxWidth,
                            margin: "0 auto",
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-start",
                        }}
                    >
                        <Button
                            style={{
                                height: "40px",
                                borderRadius: Tokens.radiusControl,
                            }}
                            onClick={() => {
                                backCTAAction();
                                mpTapGoBack({ screen: "BUY_SELL_FORM" });
                            }}
                        >
                            Back
                        </Button>
                    </div>
                }
            >
                <div
                    style={{
                        maxWidth: Tokens.containerMaxWidth,
                        margin: "0 auto",
                        width: "100%",
                    }}
                >
                    {component}
                </div>
            </Drawer>
        </div>
    );
};

export default Transaction;
